import React, { Component } from 'react'
import bem from '../../../common/bem'

export default class PageWrapper extends Component {
  constructor() {
    super()
  }

  render() {

    const className = 'pagewrapper'
    const { children, isSidebarOpen } = this.props
    return (
      <div className={
        bem(className).element('container').modifier(isSidebarOpen ? 'sidebar-active' : 'sidebar-inactive') }>
        { children }
      </div>
    )
  }
}

PageWrapper.defaultProps = {
  isSidebarOpen: false
}



// WEBPACK FOOTER //
// ./component/ui/Page/PageWrapper.js